/**
 * Responsive shenanigans
 */
export default function responsive() {
    let lastWindowWidth = $(window).outerWidth();

    function resize(firstPaint = false) {
        let windowWidth = $(window).outerWidth();

        switchToCollapse(windowWidth, firstPaint);

        lastWindowWidth = windowWidth;
    }

    function titlesToCollapse() {
        $('.switch-to-collapse h2').each(function() {
            let $anchor = $(this).find('a[name]');
            if ($anchor.length) {
                $anchor.removeAttr('tabindex').attr({
                    'data-toggle': "collapse",
                    'href': "#switch-to-collapse-collapsible-"+$anchor.attr('name'),
                    'role': "button",
                    'aria-expanded': "false",
                    'aria-controls': "switch-to-collapse-collapsible-"+$anchor.attr('name')
                });

                let $collapse = $("<div class=\"collapse\" id=\"switch-to-collapse-collapsible-" + $anchor.attr('name') + "\"></div>");
                let $next = $(this);
                let $collapsibleElements = [];
                while ($next.next().length) {
                    $next = $next.next();
                    
                    if ($next.is( "h2" )) break;
                    $collapsibleElements.push($next);
                }
                $collapse.append($collapsibleElements);
                $collapse.insertAfter($(this));
            }
        });
    }

    function titlesFromCollapse() {
        $('.switch-to-collapse h2').each(function() {
            let $anchor = $(this).find('a[name]');
            if ($anchor.length) {
                $anchor.removeAttr('data-toggle href role aria-expanded aria-controls').attr({
                    'tabindex': "-1",
                });
                
                $("#switch-to-collapse-collapsible-"+$anchor.attr('name')).removeClass('collapse show');
            }
        });
    }

    function switchToCollapse(windowWidth, firstPaint = false) {
        if (lastWindowWidth >= 992 && windowWidth < 992 || firstPaint && windowWidth < 992) { // switch from lg to md
            titlesToCollapse();
        } else if (lastWindowWidth < 992 && windowWidth >= 992) { // switch from md to lg
            titlesFromCollapse();
        }
    }

    $(window).on('resize', () => resize());

    $(document).ready(function() {
        resize(true);
    });
}